import {
  ADD_AWARD_CATEGORY_FAILURE,
  ADD_AWARD_CATEGORY_REQUEST,
  ADD_AWARD_CATEGORY_RESET,
  ADD_AWARD_CATEGORY_SUCCESS,
} from "../../../types/awards"

const initialState = {
  loading: false,
  message: "",
  error: "",
  success: false,
}

const addAwardCategoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_AWARD_CATEGORY_REQUEST:
      return {
        ...state,
        loading: true,
        message: "",
        error: "",
        success: false,
      }

    case ADD_AWARD_CATEGORY_SUCCESS:
      return {
        ...state,
        loading: false,
        message: action.payload.message,
        error: "",
        success: true,
      }

    case ADD_AWARD_CATEGORY_FAILURE:
      return {
        ...state,
        loading: false,
        message: "",
        error: action.payload.message,
        success: false,
      }

    case ADD_AWARD_CATEGORY_RESET:
      return { ...initialState }

    default:
      return state
  }
}

export default addAwardCategoryReducer
